import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { SocialsData } from "../../content.types";
import { requestGetSocials } from "./requestGetSocials.request";

const useGetSocials = (
  options?: QueryOptions<SocialsData, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["content-socials"],
    queryFn: async () => await requestGetSocials(),
    onError: toastServerError,
    ...options
  });

  return { socialsData: data, ...rest };
};

export default useGetSocials;
